var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.058 13.516-1.614 6.99a1.081 1.081 0 0 0 1.657 1.144l5.898-3.932 5.9 3.932a1.085 1.085 0 0 0 1.642-1.198l-1.98-6.933 4.913-4.422a1.083 1.083 0 0 0-.639-1.885l-6.176-.492L11.986.804a1.081 1.081 0 0 0-1.973 0L7.34 6.72l-6.176.49a1.083 1.083 0 0 0-.67 1.856zM8.15 8.829a1.081 1.081 0 0 0 .901-.635L11 3.881l1.948 4.313a1.081 1.081 0 0 0 .902.635l4.303.341-3.544 3.19c-.308.277-.43.704-.317 1.102l1.357 4.75-4.047-2.698a1.078 1.078 0 0 0-1.202 0l-4.229 2.82 1.137-4.925a1.083 1.083 0 0 0-.299-1.018L3.72 9.182z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.9bcfb159.svg";
export { ForwardRef as ReactComponent };